import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';
import { Direction } from 'webapp/enums/enums';

import CommonPopupsDataStatusComponent from 'webapp/components/common/popups/data-status';

import type Source from 'webapp/models-custom/source';
import type StatusObject from 'webapp/models-custom/status-object';

export interface Args {
	context: string;
	lastSync: number | null;
	popupTheme?: string;
	statusObjects?: StatusObject[];
	statusObjectLabels?: Map<StatusObject, string>;
	skipActions?: boolean;
	openEnableCustomDataUpdatePopup?: () => void;
	boardSources?: Source[];
}

export default abstract class DataStatusBaseComponent<T extends Args> extends Component<T> {
	@service declare popup: Service.Popup;
	@service('navigation') declare navigationService: Service.Navigation;

	abstract offset: number;

	get showActions(): boolean {
		return !this.args.skipActions;
	}

	@action
	clickAction(e: MouseEvent): void {
		// only for mobile subpages
		this.openPopup(e.target as HTMLElement);
	}

	@action
	openPopup(el: HTMLElement) {
		const popup = this.popup.createContext(CommonPopupsDataStatusComponent, el, {
			popupClass: 'popup-type-data-status',
			offset: this.offset,
			directions: [Direction.UP, Direction.DOWN, Direction.RIGHT, Direction.LEFT],
			theme: this.args.popupTheme,
		});

		return popup.open({
			context: this.args.context,
			lastSync: this.args.lastSync,
			showActions: this.showActions,
			statusObjects: this.args.statusObjects,
			statusObjectLabels: this.args.statusObjectLabels,
			openEnableCustomDataUpdatePopup: this.args.openEnableCustomDataUpdatePopup,
			boardSources: this.args.boardSources,
		});
	}
}
